import { HttpParams } from '@angular/common/http';
import { Empfaenger } from '../../../pdf-viewer/kiene-pdf-viewer/classes/empfaenger';

export class GruppeReklamationPdfHaendlerAuswahlDialogOutput {
    params: HttpParams;
    empfaenger: Empfaenger;
}
